import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IStatementPrinterFormMeta {
  statementPrinterState: FormInputMeta;
  statementPrinterPrinter: FormInputMeta;
  statementPrinterPaper: FormInputMeta;
  statementPrinterRibbon: FormInputMeta;
  statementPrinterHead: FormInputMeta;
  statementPrinterKnife: FormInputMeta;
  statementPrinterBinCatch: FormInputMeta;

}

const statementPrinterFormMeta = {} as IStatementPrinterFormMeta;

statementPrinterFormMeta.statementPrinterState = {
    name: "statementPrinterState",
    type: "select",
    label: "Etat",
    validation: yup.string().required("Champ obligatoire !"),
};

statementPrinterFormMeta.statementPrinterPrinter = {
    name: "statementPrinterPrinter",
    type: "select",
    label: "Imprimante",
    validation: yup.string().required("Champ obligatoire !"),
};

statementPrinterFormMeta.statementPrinterPaper = {
    name: "statementPrinterPaper",
    type: "select",
    label: "Papier",
    validation: yup.string().required("Champ obligatoire !"),
};

statementPrinterFormMeta.statementPrinterRibbon = {
    name: "statementPrinterRibbon",
    type: "select",
    label: "Ribbon",
    validation: yup.string().required("Champ obligatoire !"),
};

statementPrinterFormMeta.statementPrinterHead = {
    name: "statementPrinterHead",
    type: "select",
    label: "Tête",
    validation: yup.string().required("Champ obligatoire !"),
};

statementPrinterFormMeta.statementPrinterKnife = {
    name: "statementPrinterKnife",
    type: "select",
    label: "Couteau",
    validation: yup.string().required("Champ obligatoire !"),
};

statementPrinterFormMeta.statementPrinterBinCatch = {
    name: "statementPrinterBinCatch",
    type: "select",
    label: "Capture bin",
    validation: yup.string().required("Champ obligatoire !"),
};

export default statementPrinterFormMeta;